exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".remove-padding {\n  padding: 0px !important; }\n\n.location-font-size {\n  font-size: 15px; }\n\n.created-date-width {\n  width: 105px; }\n\n.table-margin-top-10 {\n  margin-top: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/monthly_report/monthly_report.scss
// module id = 1003
// module chunks = 1